define('core/utils/metatags',[
    'jquery',
    'underscore',
    'backbone',
    'core/utils/html',
    'core/strings',
], function (
    $,
    _,
    Backbone,
    html,
    strings
) {
    'use strict';

    var gettext = strings.get;


    // Mapping of attribute name we support to the selector
    // attributes used to lookup the meta tags.
    //
    // For instance, `metatags.set({url: 'Hello'})` will
    // find or create the meta tags [name=twitter:url] and
    // [property=og:url] and set their `content` attributes
    // to 'Hello'.
    var META_TAGS = {
        type: [
            'property="og:type"',
        ],
        title: [
            'property="og:title"',
            'name="twitter:title"',
        ],
        description: [
            'name="twitter:description"',
            'property="og:description"',

            // The page's normal description tag
            'name="description"',

        ],
        image: [
            'property="og:image"',
            'name="twitter:image"',
        ],
        url: [
            'property="og:url"',
            'name="twitter:url"',
        ],
        _card: [
            'name="twitter:card"',
        ],
    };

    var withScheme = function (url) {
        if (url.indexOf('//') === 0)
            url = 'https:' + url;
        return url;
    };

    var DEFAULTS = {
        type: 1,
        title: 'Disqus',
        description: gettext('The web\'s community of communities now has one central hub.'),

        // FB and Twitter don't assume schemes when scraping our content.
        // TODO: this image url could change and should be set by config.
        image: withScheme('//c.disquscdn.com/home/current/img/brand/favicon-192x192.png'),
        url: 'https://disqus.com/',
        _card: 'summary',
    };

    var metatagUtils = _.extend({
        DEFAULTS: DEFAULTS,
        META_TAGS: META_TAGS,

        /**
         * Set the document title and social meta tag attributes
         * with the passed parameters. This supports setting:
         *     `type`
         *     `title`
         *     `description`
         *     `image`
         *     `url`
         *
         * One parameter - `twitter:card` - is only supported as 'summary' at this point,
         * so it's prefixed with an underscore.
         *
         * If any required parameter is not passed, defaults to `this.DEFAULTS`.
         *
         */
        set: function (options) {
            options = options || {};

            // If `set` is passed a string, we assume it's a title
            // and the rest of the tags will be defaults.
            if (_.isString(options))
                options = { title: options };

            // First clean our title (we could end up with an empty string, so important to do here).
            if (options.title)
                options.title = html.stripTags(options.title);

            // If we have a title, then we prepend 'Disqus' to it.
            if (options.title)
                options.title += ' · Disqus';

            if (!options.url)
                options.url = String(window.document.location).split('?')[0];

            options.url = withScheme(options.url);

            if (options.image)
                options.image = withScheme(options.image);

            if (options.description)
                options.description = html.stripTags(options.description);

            var $head = $('head');
            _.each(META_TAGS, function (attributes, key) {
                _.each(attributes, function (attribute) {
                    var tag = $head.find('[' + attribute + ']');
                    if (!tag.length) {
                        tag = $('<meta ' + attribute + '>');
                        $head.append(tag);
                    }
                    tag.attr('content', options[key] || DEFAULTS[key]);
                });
            });

            window.document.title = options.title || DEFAULTS.title;

            metatagUtils.trigger('change:metatags');
        },
    }, Backbone.Events);

    return metatagUtils;
});

